import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const useRecoleccionProvinciaBarras = (year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(new AbortController());

  useEffect(() => {
    if (!token || !idAdministrador) return;

    setLoading(true);
    setError(null);

     
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();

    const fetchData = async () => {
      try {
         

        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerRecoleccionProvincia`,
          { 
            anio: year, 
            mes: mes, 
            id_administrador: idAdministrador,
            provincia: provinciaSeleccionada || null,
            ciudad: ciudadSeleccionada || null
          },
          { 
            headers: { Authorization: token },
            signal: abortControllerRef.current.signal 
          }
        );

         
        setData(response.data || []);
        setError(null);
      } catch (error) {
        if (error.name === 'AbortError') {
           
          return;
        }
         
        setError(error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada]);

  return { data, loading, error };
};

export default useRecoleccionProvinciaBarras;